import React, { Component } from "react";

export default class BLOCK8 extends Component {
  render() {
    return (
        <div id="block-8" style={{ padding: "3px 3px 3px 3px" }}>
            <div
                id="menu-title"
                style={{
                    backgroundImage: "url(images/PureGreenBar.png)",
                    color: "Drakgray"
                }}
            >
                Tip การใช้งานระบบ
                        </div>
            <div style={{ textAlign: "left" }}>
                <title>FAQ</title>
                <p>
                    <span id="Q_TIP">
                        หากลงทะเบียนแล้วไม่ได้รับอีเมลตอบกลับจากระบบ
                            </span>
                    <br />
                    ให้ตรวจสอบอีเมลใน spam mail หรือ junk mail ก่อน
                    ซึ่งบางครั้งระบบรักษาความปลอดภัยอีเมลของท่านอาจมองอีเมลของ
                    พพ. เป็นอีเมลที่ไม่รู้จัก
                    หากตรวจสอบแล้วแน่ใจว่าไม่พบให้แจ้งเจ้าหน้าที่ของ พพ.
                    เพื่อตรวจสอบ และส่งอีเมลให้อีกครั้ง
                    เนื่องจากอีเมลที่ท่านลงทะเบียนอาจมีการพิมพ์ผิดโดยที่ไม่ทราบ
                    หรืออาจมีรหัสอักษรอื่นๆ พิมพ์ติดเข้าไปด้วย
                    ทำให้ระบบส่งอีเมลไปผิดที่ หรือ ส่งไม่ได้
                          </p>
                <p>
                    <span id="Q_TIP">
                        หากได้รับรหัสผ่านจากอีเมลแล้วแต่ไม่สามารถล็อกอินเข้าสู่ระบบได้{" "}
                    </span>
                    <br />
                    ให้ตรวจสอบรหัสผ่านว่าท่านพิมพ์ตัวอักษรผิดหรือไม่เช่น
                    ตัว l (แอลเล็ก) เป็น ตัว I (ไอใหญ่) หรือเลข 1
                    หรือคีย์บอร์ดของท่านเป็นรหัสภาษาไทยอยู่หรือไม่ หรือ
                    คีย์บอร์ดของท่านอยู่ในสถานะ Cap Lock หรือ Num Lock
                    หรือไม่ อีกกรณีให้ตรวจสอบอีเมลที่ลงทะเบียน
                    เป็นอักษรตัวพิมพ์ใหญ่ หรือตัวพิมพ์เล็ก
                    เหมือนกับที่ใช้ล็อกอินหรือไม่
                    เนื่องจากตัวอักษรพิมพ์ใหญ่พิมพ์เล็กมีผลต่อการเข้าใช้งาน
                          </p>
                <p>
                    <span id="Q_TIP">
                        หากเคยลงทะเบียนขอใช้ระบบมาแล้ว
                        แต่จำรหัสผู้บันทึกข้อมูลไม่ได้ หรือ
                        จำรหัสผู้ยืนยันการส่งรายงานไม่ได้
                            </span>
                    <br />
                    ให้ทำการลงทะเบียนขอใช้ระบบใหม่อีกครั้ง โดยระบุ
                    TSIC-ID และรหัส 32 หลักเดิมที่เคยลงทะเบียน
                    หลังจากนั้นระบบก็จะแสดงข้อมูลต่างๆ ให้ทราบ
                          </p>
                <p>
                    <span id="Q_TIP">
                        หากลืมรหัสผ่านของผู้บันทึก
                        หรือผู้ยืนยันการส่งรายงาน
                            </span>
                    <br />
                    ให้เข้าสู่หน้าจอล็อกอินแล้วเลือกเมนู ลืมรหัสผ่าน
                    แล้วดำเนินขั้นตอนตามคำแนะนำของระบบ
                    ซึ่งระบบจะส่งอีเมลเพื่อให้ท่านทราบก่อนว่าจะขอรีเซ็ทรหัสผ่านเดิม
                    หากยืนยันให้ท่านดำเนินการตามขั้นตอนในอีเมลแล้วระบบจะส่งรหัสผ่านใหม่ให้ผ่าน
                    อีเมลอีกฉบับ
                          </p>
                <p>
                    <span id="Q_TIP">
                        การ upload ภาพสำหรับเป็นข้อมูลในขั้นตอนต่างๆ
                        ของแบบ E-Form ไม่สำเร็จ
                            </span>
                    <br />
                    <u>กรณีที่ 1</u> ขนาดไฟล์ภาพมีขนาดไม่เกินตามที่ พพ.
                    กำหนด แต่ไม่สามารถ upload ได้
                    ให้้ผู้ใช้งานทดสอบโดยใช้เครือข่ายอินเตอร์เน็ตจากภายนอกแล้วลอง
                    upload ไฟล์ภาพดังกล่าวใหม่ หาก upload ได้
                    แสดงว่าโรงงาน/อาคารของท่านมีการบล็อกการ upload
                    ไฟล์สู่อินเตอร์เน็ต
                    ดังนั้นผู้ใช้งานจะต้องติดต่อผู้ดูแลระบบในองค์กรของท่านเองเพื่อแก้ปัญหาต่อไป
                            <br />
                    <u>กรณีที่ 2</u> upload
                    ไฟล์ภาพแล้วปรากฎว่าเป็นภาพเดิมไม่เปลี่ยนแปลง
                    ให้ผู้ใช้งานทำการ Refresh Web Page จากเมนูของ Web
                    Browser หรือให้นำเมาส์ไปคลิ๊กที่ช่อง URL Address
                    แล้วกดปุ่ม F5 หรือ ให้ผู้ใช้งานทำการลบแคชของ Browser
                    นั้นก่อน
                    ทั้งนี้การที่ภาพไม่เปลี่ยนเนื่องมาจากแคชอินเตอร์เน็ตของผู้ใช้งานไม่ไ้ด้
                    Refresh อัตโนมัติ
                          </p>
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/block/block-8.js